module.exports = __webpack_public_path__ + "img/camera-white.e8e6c817.svg";